import {
  fontsize12,
  fontsize16,
  poppins400,
  poppins500,
} from 'theme/common.style';

export const bgImageContainer = (img) => ({
  width: '100%',
  height: '323px',
  backgroundSize: 'cover',
  backgroundRepeat: 'no-repeat',
  borderRadius: '10px 10px 0px 0px',
  backgroundImage: `linear-gradient(to bottom, rgba(255, 255, 255, 0), rgba(0, 0, 0, 0.5)),url("${img}")`,
});

export const bgBtnCont = (color) => ({
  background: color,
  borderRadius: '5px',
  padding: '0px 5px',
  fontFamily: "'Poppins'",
  fontStyle: 'normal',
  fontWeight: '400',
  fontSize: '14px',
  textAlign: 'center',
  color: '#FFFFFF',
});

export const auctionData = {
  background: '#383837',
  borderRadius: '5px',
  padding: '6px',
  textAlign: 'center',
  color: 'white',
  textTransform: 'uppercase',
  margin: '5px 0px',
  ...poppins400,
  ...fontsize12,
};
export const countValue = {
  ...poppins500,
  ...fontsize16,
  color: 'white',
  paddingRight: '15px',
  display: 'flex',
};
export const WatchEye = {
  color: 'blue',
};

export const highStarStyle = {
  width: '12px',
  height: '12px',
};
